import React from "react";
import Loadable from "../../react-loadable";

const WeaSwitch = Loadable({
  loader: () => import("./Switch"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

export default WeaSwitch;



// WEBPACK FOOTER //
// ./ecology9/wea-switch/index.js